<script setup></script>

<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_7831_12087)">
      <path
        d="M15.5834 19.25V17.4167C15.5834 16.4442 15.197 15.5116 14.5094 14.8239C13.8218 14.1363 12.8891 13.75 11.9167 13.75H4.58335C3.61089 13.75 2.67826 14.1363 1.99063 14.8239C1.303 15.5116 0.916687 16.4442 0.916687 17.4167V19.25M21.0834 19.25V17.4167C21.0827 16.6043 20.8123 15.815 20.3146 15.173C19.8169 14.5309 19.12 14.0723 18.3334 13.8692M14.6667 2.86917C15.4554 3.07111 16.1545 3.52981 16.6537 4.17295C17.1529 4.81609 17.4239 5.60709 17.4239 6.42125C17.4239 7.23541 17.1529 8.02641 16.6537 8.66955C16.1545 9.31269 15.4554 9.77139 14.6667 9.97333M11.9167 6.41667C11.9167 8.44171 10.2751 10.0833 8.25002 10.0833C6.22498 10.0833 4.58335 8.44171 4.58335 6.41667C4.58335 4.39162 6.22498 2.75 8.25002 2.75C10.2751 2.75 11.9167 4.39162 11.9167 6.41667Z"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
